import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useSeo } from "@/lib/seo";
import { IMAGES } from "@/constants/images";
import { Reveal } from "@/components/Reveal";

export default function Services() {
  const { t, lang, services: svcData } = useApp();
  useSeo("services");
  const sv = (k, f, fb) => (svcData?.[k]?.[f] && (svcData[k][f][lang] || svcData[k][f].de)) || fb;
  const services = [
    { key: "fenster", img: IMAGES.window, name: sv("fenster", "name", t.services.fenster.name), desc: sv("fenster", "desc", t.services.fenster.desc), points: t.about.chapters.map((c) => c.t) },
    { key: "sonnenschutz", img: IMAGES.terrace, name: sv("sonnenschutz", "name", t.services.sonnenschutz.name), desc: sv("sonnenschutz", "desc", t.services.sonnenschutz.desc), points: t.about.chapters.map((c) => c.t) },
  ];
  return (
    <div className="pt-32 md:pt-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-widest text-accent2">{t.nav.services}</span>
          <h1 className="mt-3 font-display font-black text-5xl md:text-7xl tracking-tighter max-w-3xl">{t.services.title}</h1>
          <p className="mt-6 max-w-xl text-lg text-slate-600">{t.services.sub}</p>
        </Reveal>
      </div>
      <div className="mt-16 md:mt-24 space-y-0">
        {services.map((s, i) => (
          <section key={s.key} className={i % 2 ? "bg-slate-50 border-y border-slate-200" : ""}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 grid lg:grid-cols-2 gap-10 md:gap-16 items-center">
              <Reveal className={i % 2 ? "lg:order-2" : ""}>
                <div className="aspect-[4/3] overflow-hidden border border-slate-200">
                  <img src={s.img} alt={s.name} className="w-full h-full object-cover" />
                </div>
              </Reveal>
              <Reveal delay={0.1} className={i % 2 ? "lg:order-1" : ""}>
                <span className="font-display font-black text-6xl text-slate-200">0{i + 1}</span>
                <h2 className="mt-2 font-display font-bold text-3xl md:text-4xl tracking-tight" data-testid={`service-title-${s.key}`}>{s.name}</h2>
                <p className="mt-4 text-slate-600 leading-relaxed text-lg">{s.desc}</p>
                <ul className="mt-8 space-y-3">
                  {s.points.map((p, k) => (
                    <li key={k} className="flex items-center gap-3 font-medium"><Check size={18} className="text-accent2" />{p}</li>
                  ))}
                </ul>
                <Link to="/kontakt" className="mt-8 inline-flex items-center gap-2 bg-brand text-white font-semibold px-6 py-3.5 hover:bg-accent2 transition-colors">
                  {t.services.more} <ArrowRight size={18} />
                </Link>
              </Reveal>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
